export const meerpV2TH: Record<string, string> = {
  MEERP_STATUS_TO_BILL: "รับครบ รอวางบิล",
  MEERP_STATUS_TO_RECEIVE: "วางบิลแล้ว รอรับยา",
  MEERP_COMPLETED_WITHOUT_BILLING_DATA: "เสร็จสิ้นตามสถานะ PO (ไม่มีข้อมูลวางบิล)",
  MEERP_PERCENT_RECEIVED: "% รับยา",
  MEERP_PERCENT_BILLED: "% วางบิล",
  MEERP_ACCEPTED_TO_DATE: "รับดีสะสมตาม PO",
  MEERP_DELIVERED_QUANTITY: "จำนวนส่งถึง",
  MEERP_ACCEPTED_QUANTITY: "จำนวนรับดี",
  MEERP_REJECTED_QUANTITY: "จำนวนปฏิเสธ",
  MEERP_REJECTION_REASON: "เหตุผลปฏิเสธ",
  MEERP_REJECTED_STORAGE: "คลังพักของปฏิเสธ",
  MEERP_PACKAGE_UNIT: "หน่วยซื้อ/บรรจุ",
  MEERP_BASE_UNIT: "หน่วยฐาน",
  MEERP_CONVERSION_FACTOR: "ตัวคูณหน่วยฐาน",
  MEERP_STOCK_QUANTITY: "จำนวนหน่วยฐาน (server)",
  MEERP_REJECTED_STOCK_QUANTITY: "จำนวนปฏิเสธหน่วยฐาน",
  MEERP_PACKAGE_COST: "ทุนต่อหน่วยซื้อ",
  MEERP_BASE_UNIT_COST: "ทุนต่อหน่วยฐาน",
  MEERP_INVOICED_QUANTITY: "จำนวนวางบิล",
  MEERP_BILLED_AMOUNT: "ยอดวางบิล",
  MEERP_PRODUCT_ID: "ID ยา",
  MEERP_PO_ID: "ID ใบสั่งซื้อ",
  MEERP_RECEIPT_ID: "ID ใบรับยา",
  MEERP_PO_LINE_ID: "ID รายการ PO",
  MEERP_RECEIPT_LINE_ID: "ID รายการรับยา",
  MEERP_UNIT_SERVER_NOTE: "จำนวนและราคาหน่วยฐานใช้ค่าจากหลังบ้าน ยังไม่ระบุชื่อหน่วยฐานในสัญญา ช่องที่ไม่ส่งมาแสดง — ไม่ถือว่าเป็นศูนย์หรือตัวคูณหนึ่ง",
  MEERP_RECEIPT_QUANTITY_NOTE: "จำนวนส่งถึงรวมรับดีและปฏิเสธ จำนวนรับดีเพียงอย่างเดียวยังไม่ยืนยันว่าลง stock หรือส่งบัญชีแล้ว หากไม่มีข้อมูลคัดแยกจะไม่อนุมานจากจำนวนส่งถึง",
  MEERP_BILLING_NOT_PAYMENT: "สถานะและยอดวางบิลไม่ใช่การชำระเงินแล้ว",
  MEERP_SINGLE_STATUS_NOTE: "แสดงทีละสถานะที่เลือก ไม่ใช่ยอดรวม PO รอรับทุกสถานะ",
  MEERP_VENDOR_DOCUMENTS: "เอกสารผู้ขาย",
  MEERP_BANK_TEMPLATES: "แบบพิมพ์และรายงานธนาคาร",
  MEERP_DOCUMENT_DETAIL: "รายละเอียดเอกสารผู้ขาย",
  MEERP_DOCUMENT_LINES: "รายการในเอกสารผู้ขาย",
  MEERP_DOCUMENT_VERIFICATION: "การตรวจเอกสาร",
  MEERP_DOCUMENT_VERIFIED: "ยืนยันเอกสารแล้ว",
  MEERP_DOCUMENT_UNVERIFIED: "ยังไม่ยืนยันเอกสาร",
  MEERP_ALL_DOCUMENT_TYPES: "ทุกประเภทเอกสาร",
  MEERP_DOC_TYPE_inv: "ใบแจ้งหนี้",
  MEERP_DOC_TYPE_tax_inv: "ใบกำกับภาษี",
  MEERP_DOC_TYPE_rcp: "ใบเสร็จรับเงิน",
  MEERP_DOC_TYPE_tax_inv_rcp: "ใบเสร็จรับเงิน/ใบกำกับภาษี",
  MEERP_DOC_TYPE_dlv: "ใบส่งของ",
  MEERP_DOC_TYPE_crd: "ใบลดหนี้",
  MEERP_DOC_TYPE_wht: "หนังสือรับรองหัก ณ ที่จ่ายที่บันทึกไว้",
  MEERP_TAXABLE_AMOUNT: "มูลค่าที่ต้องเสีย VAT",
  MEERP_EXEMPT_AMOUNT: "มูลค่ายกเว้น VAT",
  MEERP_PRICE_VARIANCE: "ผลต่างราคา (server)",
  MEERP_HAS_PRICE_VARIANCE: "พบผลต่างราคา",
  MEERP_INVOICE_UNIT_COST: "ราคาต่อหน่วยตามเอกสาร",
  MEERP_NOTES: "หมายเหตุ",
  MEERP_INVOICE_UNITS_NOTE: "แสดงจำนวน ราคา และผลต่างตามหลังบ้าน ยังไม่มีหน่วย/ตัวคูณของรายการใบแจ้งหนี้ จึงไม่คำนวณเทียบราคาข้ามหน่วยเอง",
  MEERP_LOAD_PAGED_LINES: "โหลดรายการแบบแบ่งหน้า",
  MEERP_OPEN_ATTACHMENT: "เปิดไฟล์แนบผู้ขาย",
  MEERP_NO_ATTACHMENT: "ไม่มีลิงก์ไฟล์แนบที่เปิดได้",
  MEERP_ATTACHMENT_NOT_PRINT: "ไฟล์แนบเป็นเอกสารที่บันทึกไว้ ไม่ใช่แบบพิมพ์ธนาคารที่ระบบสร้าง",
  MEERP_VERIFY_DOCUMENT: "ยืนยันเอกสารวางบิล",
  MEERP_DOCUMENT_VERIFY_PENDING: "ยังไม่เปิดยืนยันเอกสาร: รอ payload, สิทธิ์ และกฎยืนยันซ้ำ/แก้หลังยืนยัน การยืนยันมีผลต่อยอดวางบิล PO ไม่ใช่การจ่ายเงินจริง",
};

export const meerpV2EN: Record<string, string> = {
  MEERP_STATUS_TO_BILL: "Received, awaiting billing",
  MEERP_STATUS_TO_RECEIVE: "Billed, awaiting receipt",
  MEERP_COMPLETED_WITHOUT_BILLING_DATA: "PO completed (billing data unavailable)",
  MEERP_PERCENT_RECEIVED: "Received %",
  MEERP_PERCENT_BILLED: "Billed %",
  MEERP_ACCEPTED_TO_DATE: "Accepted to date (PO)",
  MEERP_DELIVERED_QUANTITY: "Delivered quantity",
  MEERP_ACCEPTED_QUANTITY: "Accepted quantity",
  MEERP_REJECTED_QUANTITY: "Rejected quantity",
  MEERP_REJECTION_REASON: "Rejection reason",
  MEERP_REJECTED_STORAGE: "Rejection storage",
  MEERP_PACKAGE_UNIT: "Purchase/package unit",
  MEERP_BASE_UNIT: "Base unit",
  MEERP_CONVERSION_FACTOR: "Base-unit multiplier",
  MEERP_STOCK_QUANTITY: "Base quantity (server)",
  MEERP_REJECTED_STOCK_QUANTITY: "Rejected base quantity",
  MEERP_PACKAGE_COST: "Cost per purchase unit",
  MEERP_BASE_UNIT_COST: "Cost per base unit",
  MEERP_INVOICED_QUANTITY: "Invoiced quantity",
  MEERP_BILLED_AMOUNT: "Billed amount",
  MEERP_PRODUCT_ID: "Product ID",
  MEERP_PO_ID: "Purchase order ID",
  MEERP_RECEIPT_ID: "Goods receipt ID",
  MEERP_PO_LINE_ID: "PO line ID",
  MEERP_RECEIPT_LINE_ID: "Receipt line ID",
  MEERP_UNIT_SERVER_NOTE: "Base quantities and costs are server values. The contract does not identify the base unit. Missing fields show —, not zero or a multiplier of one.",
  MEERP_RECEIPT_QUANTITY_NOTE: "Delivered includes accepted and rejected goods. Accepted quantity alone does not prove stock or accounting was updated. Missing quality quantities are not inferred from delivered quantity.",
  MEERP_BILLING_NOT_PAYMENT: "Billing status and billed amounts do not mean payment has been made.",
  MEERP_SINGLE_STATUS_NOTE: "Only the selected status is shown, not all purchase orders awaiting receipt.",
  MEERP_VENDOR_DOCUMENTS: "Vendor documents",
  MEERP_BANK_TEMPLATES: "Bank templates and reports",
  MEERP_DOCUMENT_DETAIL: "Vendor document details",
  MEERP_DOCUMENT_LINES: "Vendor document lines",
  MEERP_DOCUMENT_VERIFICATION: "Document verification",
  MEERP_DOCUMENT_VERIFIED: "Document verified",
  MEERP_DOCUMENT_UNVERIFIED: "Not verified",
  MEERP_ALL_DOCUMENT_TYPES: "All document types",
  MEERP_DOC_TYPE_inv: "Invoice",
  MEERP_DOC_TYPE_tax_inv: "Tax invoice",
  MEERP_DOC_TYPE_rcp: "Receipt",
  MEERP_DOC_TYPE_tax_inv_rcp: "Tax invoice and receipt",
  MEERP_DOC_TYPE_dlv: "Delivery note",
  MEERP_DOC_TYPE_crd: "Credit note",
  MEERP_DOC_TYPE_wht: "Recorded withholding certificate",
  MEERP_TAXABLE_AMOUNT: "VAT-taxable amount",
  MEERP_EXEMPT_AMOUNT: "VAT-exempt amount",
  MEERP_PRICE_VARIANCE: "Price variance (server)",
  MEERP_HAS_PRICE_VARIANCE: "Price variance found",
  MEERP_INVOICE_UNIT_COST: "Invoiced unit price",
  MEERP_NOTES: "Notes",
  MEERP_INVOICE_UNITS_NOTE: "Quantities, prices and variance come from the server. Invoice line units and conversion factors are not specified; no cross-unit comparison is calculated here.",
  MEERP_LOAD_PAGED_LINES: "Load paginated lines",
  MEERP_OPEN_ATTACHMENT: "Open vendor attachment",
  MEERP_NO_ATTACHMENT: "No usable attachment link",
  MEERP_ATTACHMENT_NOT_PRINT: "An attachment is a recorded document, not a bank-approved print generated by this system.",
  MEERP_VERIFY_DOCUMENT: "Verify billing document",
  MEERP_DOCUMENT_VERIFY_PENDING: "Verification is disabled pending payload, permissions and re-verification/edit rules. Verification affects PO billing, not actual payment.",
};
